import { render } from "./ExerciseList.vue?vue&type=template&id=4319993e"
import script from "./ExerciseList.vue?vue&type=script&lang=js"
export * from "./ExerciseList.vue?vue&type=script&lang=js"

import "./ExerciseList.vue?vue&type=style&index=0&id=4319993e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__